module.exports = __webpack_public_path__ + "static/img/pro-7-4-1.7f48cbf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zbqfBrand/pro-7-4-1.png
// module id = Dql7
// module chunks = 0